import SET_IS_LOCKED from './constants';

export const setIsLocked = isLocked => ({
    type: SET_IS_LOCKED,
    isLocked,
});

export const createProject = project => (dispatch) => {
    dispatch({ type: 'CREATE_PROJECT', project });
};



// WEBPACK FOOTER //
// ./src/containers/IsLocked/actions.js